export enum AnalyseScoreMapActionTypes {
  CHANGE_WORLD_VIEW = '[Analyse Score Map] Change World View',
}

export class AnalyseScoreMapChangeWorldView {
  public readonly type = AnalyseScoreMapActionTypes.CHANGE_WORLD_VIEW;
  constructor(public payload: { worldViewSelected: boolean }) {}
}

export type AnalyseScoreMapActionsUnion = AnalyseScoreMapChangeWorldView;
